const accessStates = ['active', 'trialing', 'started'];
const existingStates = [...accessStates, 'past_due', 'unpaid', 'incomplete', 'paused'];
const states = [...existingStates, 'inactive', 'canceled', 'incomplete_expired'];
const truth = value => value === true || value === 'true';
export const membershipStatus = data => String(data?.billing?.status || data?.membership_status || '').toLowerCase();
export function validateMembershipStatus(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data) ||
      !['membership_status', 'membershipactive', 'active', 'onboardingcomplete'].some(key => key in data) ||
      (!membershipStatus(data) && !['membershipactive', 'active', 'onboardingcomplete'].some(key => key in data)) ||
      ['active', 'hasMembership'].some(key => key in data && typeof data[key] !== 'boolean') ||
      ['membershipactive', 'onboardingcomplete'].some(key => key in data && ![true, false, 'true', 'false'].includes(data[key])) ||
      (membershipStatus(data) && !states.includes(membershipStatus(data)))) {
    throw new Error('Membership status is unavailable. Please retry before continuing.');
  }
  return data;
}
export function hasMembershipAccess(data) {
  if (typeof data?.active === 'boolean') return data.active;
  const status = membershipStatus(data);
  return status ? accessStates.includes(status) : truth(data?.membershipactive) || truth(data?.onboardingcomplete);
}
export function hasExistingMembership(data) {
  if (typeof data?.hasMembership === 'boolean') return data.hasMembership;
  const status = membershipStatus(data);
  return status ? existingStates.includes(status) : hasMembershipAccess(data);
}
export function membershipMessage(data) {
  const status = membershipStatus(data);
  if (data?.billing?.paymentRequired || ['past_due', 'unpaid', 'incomplete'].includes(status)) return 'Your membership needs a payment update.';
  if (status === 'paused') return 'Your membership is paused. Open Membership & Billing to review it.';
  if (status === 'trialing') return 'Your membership trial is active.';
  if (hasMembershipAccess(data)) return 'Your membership is active.';
  return data?.returningMember ? 'Your membership is deactivated.' : 'Your membership is not active.';
}
